export function persistAuthSession(payload = {}) {
  if (payload.token) {
    localStorage.setItem('token', payload.token);
  } else {
    localStorage.removeItem('token');
  }

  if (payload.config !== undefined) {
    localStorage.setItem('config', JSON.stringify(payload.config));
  } else {
    localStorage.removeItem('config');
  }
}

export function clearAuthSession() {
  localStorage.removeItem('token');
  localStorage.removeItem('config');
}
